import EmptyPageContent from '@app/ccf/components/empty-page-content';
import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { FoodReviewTable } from '@app/components/food-matching/food-review-table';
import Page from '@app/components/layout/page/page';
import { getReportsPathMap } from '@app/components/reports/utils';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetPurchasedFoodAndDrinkList } from '@shared/api/hooks/purchased-goods/food-and-drink';
import {
  OperationReportTypeEnum,
  PurchasedGoodsFoodListParams,
  PurchasedGoodsFoodListReviewType,
} from '@shared/api/types';
import Text from '@shared/components/content/text';
import { parseAsString, useQueryState } from 'nuqs';
import { generatePath, useNavigate } from 'react-router-dom';
import { buildFoodFilterParams, foodFilters } from '../filters';

export default function PurchasedFoodAndDrinkReviewPage() {
  const navigate = useNavigate();
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(foodFilters).map(({ column }) => column),
  });
  const [food] = useQueryState('food', parseAsString);
  const [reviewType] = useQueryState('reviewType', parseAsString);

  const params: PurchasedGoodsFoodListParams = {
    page,
    page_size: perPage,
    search: food!,
    review_type: reviewType
      ? (reviewType[0] as string)
      : (PurchasedGoodsFoodListReviewType.all as string),
    sort: formatMultipleSortingForEndpoint(
      sort! || [{ id: 'emissions', desc: true }]
    ),
    ...buildFoodFilterParams(filterStates),
  };

  const data = useGetPurchasedFoodAndDrinkList(params);
  const itemsToReview = !!data.data?.numberOfItemsToReview;
  return (
    <Page name="Food and drink review" page="subpage">
      {!itemsToReview && !data.isLoading ? (
        <EmptyPageContent
          description={
            <div className="mt-20 space-y-4">
              <Text className="text-center">
                You currently have no items to review. To ensure accuracy, as we
                process your food and drink we will flag any automatic food
                matches or extracted item weights that we think would benefit
                from a manual review
              </Text>
            </div>
          }
          primaryAction={() =>
            navigate(generatePath(getReportsPathMap()['purchase'].foodImport!))
          }
          primaryActionText="Import food and drink"
        />
      ) : (
        <FoodReviewTable
          {...data}
          reportType={OperationReportTypeEnum.purchase}
        />
      )}
    </Page>
  );
}
